import React from "react";
import { Check, X } from "lucide-react";

const IS = [
  "A governed AI-assisted documentation layer",
  "Structured workflows for CAPA, deviations, SOPs, inspection readiness",
  "Requires human review before any AI content is finalized",
  "ALCOA+ audit trail",
  "For small/midsized labs without dedicated QA",
];
const IS_NOT = [
  "A LIMS replacement",
  "A substitute for qualified QA judgment",
  "A guarantee of inspection passage",
  "An enterprise QMS (MasterControl, Qualio, Veeva)",
  "An FDA-cleared medical device",
];

function Column({ title, items, Icon, box, iconClass }) {
  return (
    <div className={`rounded-[10px] border p-7 ${box}`}>
      <h3 className="text-lg font-bold text-brand-navy mb-4">{title}</h3>
      <ul className="space-y-3">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-2.5 text-sm text-foreground/85">
            <Icon className={`w-4 h-4 shrink-0 mt-0.5 ${iconClass}`} />
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function IsIsNotGrid() {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-2 gap-6">
        <Column title="LabComplyx IS" items={IS} Icon={Check} box="bg-accent border-brand-teal/30" iconClass="text-brand-teal" />
        <Column title="LabComplyx IS NOT" items={IS_NOT} Icon={X} box="bg-card border-border" iconClass="text-muted-foreground" />
      </div>
    </section>
  );
}